var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6ad8d4c-526c-433e-9ffd-d085ef609042",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.38 398.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.b1811678-8e6d-427a-bcab-d3252333f570{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.b1811678-8e6d-427a-bcab-d3252333f570{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b02edd0a-bffa-4aad-b42c-c47e154fb5df",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M128.29,13.22,94.85,33.06a4,4,0,0,0-2,3.44V80.3a4,4,0,0,1-2,3.47L7.23,132.07a4,4,0,0,0-2,3.47L5.28,270a4,4,0,0,0,2,3.46L200.14,384.81"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b0ba23e3-c9ec-41cc-8a97-7b09eff316c6",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M128.29,13.22,94.85,33.06a4,4,0,0,0-2,3.44V80.3a4,4,0,0,1-2,3.47L7.23,132.07a4,4,0,0,0-2,3.47L5.28,270a4,4,0,0,0,2,3.46L200.14,384.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1811678-8e6d-427a-bcab-d3252333f570",
    d: "M128.29,13.22,94.85,33.06a4,4,0,0,0-2,3.44V80.3a4,4,0,0,1-2,3.47L7.23,132.07a4,4,0,0,0-2,3.47L5.28,270a4,4,0,0,0,2,3.46L200.14,384.81"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.475e2ddb.svg";
export { ForwardRef as ReactComponent };